import React from "react";
import "./filter-chips-v1.css";

export interface FilterOption<T extends string = string> {
  value: T;
  label: string;
}

interface Props<T extends string = string> {
  options: FilterOption<T>[];
  value: T;
  onChange: (value: T) => void;
}

function FilterChipsV1<T extends string = string>({
  options,
  value,
  onChange,
}: Props<T>) {
  return (
    <div className="v1-filter-chips" role="tablist">
      {options.map((opt) => (
        <button
          key={opt.value}
          className={`v1-filter-chip${value === opt.value ? " active" : ""}`}
          onClick={() => onChange(opt.value)}
          role="tab"
          aria-selected={value === opt.value}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default FilterChipsV1;
